import axios from 'axios'
import { Job } from '../models/job.model';
import { BaseService } from './base.service';
import { AssignedJob } from '@/models/assignedJob.model';
import card from '@/store/modules/card';

class JobService extends BaseService{

    constructor(){
        super();
        console.log("created a instance of JobService");
    }

    async delete(id: number){
        let result = await axios.delete(`${this.api}job/DeleteJob?id=${id}`);
        return result;
        // return this.execute('delete', `job/${id}`);
    }

    async getAll(companyId:string){
        return axios.get(`${this.api}job/GetJobList?companyId=${companyId}`).then(req => { return req.data; });
        // return this.execute('get', 'job/');
    }

    async getCount(){
        return axios.get(`${this.api}job/count`).then(req => { return req.data; });
    }

    async getAllDetail(){
        return axios.get(`${this.api}job/details/`).then(req => { return req.data; });
        // return this.execute('get', 'job/');
    }

    async getAllDetailSimple(){
        return axios.get(`${this.api}job/details/simple`).then(req => { return req.data; });
        // return this.execute('get', 'job/');
    }

    async getDetails(id: number){
        return axios.get(`${this.api}job/GetJob?id=${id}`).then(req => { return req.data; });
        // return this.execute('get', `job/${id}`);
    }

    async getScheduleDetails(id: number){
        return axios.get(`${this.api}job/schedule/${id}`).then(req => { return req.data; });
        // return this.execute('get', `job/${id}`);
    }

    async get(id: number){
        return axios.get(`${this.api}job/${id}`).then(req => { return req.data; });
        // return this.execute('get', `job/${id}`);
    }

    async create(job: Job){
        let result = await axios.post(`${this.api}job/CreateJob`, job);
        return result;
        // return this.execute('post', `job/`, job);
    }

    async update(job: Job){
        let result = await axios.put(`${this.api}job/UpdateJob`, job);
        return result;
        // return this.execute('put', `job/${job.id}`, job);
    }

    async getAllKeyValue(companyId:string, cardId:number|undefined = undefined){
        return axios.get(`${this.api}job/GetJobKeyValueList?companyId=${companyId}${cardId ? "&cardId=" + cardId: ""}`).then(req => { return req.data });
        // return this.execute('get', 'category/');
    }

    async getJobsOnPinBoard(pinboardId:number) {
        let result: any = await axios.get<any>(`${this.api}job/GetAssignedJobListOnPinBoard/?pinBoardId=${pinboardId}`);
        return result.data;
    }

    async getJobsOnPinBoardTomorrow(pinboardId:number) {
        let result: any = await axios.get<any>(`${this.api}job/GetAssignedJobListOnPinBoard/?pinBoardId=${pinboardId}&tomorrow=true`);
        return result.data;
    }

    

    async assignedJobsAll(pinboardId:number) {
        return axios.get(`${this.api}job/assignedjob/?pinBoardId=${pinboardId}`).then(req => { return req.data; });
        // return this.execute('put', `job/${job.id}`, job);
    }

    async assignedJobDone(jobDoneCommand:any){
        let result = await axios.put(`${this.api}job/AssignedJobDone/`, jobDoneCommand);
        return result.data;
    }

    async assignedJobUndo(jobUndoCommand:any) {
        let result = await axios.put(`${this.api}job/AssignedJobUndo/`, jobUndoCommand);
        return result.data;
    }

    async assignedJobMove(jobMoveCommand: any){
        let result = await axios.put(`${this.api}job/MoveAssignedJobToNewCard/`, jobMoveCommand);
        return result;
    }
}

export const jobService = new JobService();

